import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionActions from '@mui/material/AccordionActions';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Button from '@mui/material/Button';
import { Container } from 'react-bootstrap'
import axios from 'axios';

export default function Chatbot() {

    const [questions, setQuestions] = React.useState([])


    React.useEffect(() => {
        (async () => {
            const resData = await axios.get('https://api.gujjustream.com/api/chat_bot_data/')
            console.log(resData?.data)
            setQuestions(resData?.data)
        })()
    }, [])


    return (
        <section className="m-profile setting-wrapper">
            <Container>
                {
                    questions?.data?.map((data, index) => (
                        <div key={index}>
                            <h5 className='mb-3 mt-3'>
                                {data?.label}
                            </h5>
                            {data?.data?.map((data, index) => (
                                <Accordion key={index} sx={{ background: "black", color: "white", border: "1px solid white" }}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon sx={{ color: "white" }} />}
                                        aria-controls="panel1-content"
                                        id="panel1-header"
                                    >
                                        <Typography component="span">
                                            {data?.que}
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        {data?.ans}
                                    </AccordionDetails>
                                </Accordion>

                            ))}

                        </div>
                    ))
                }


            </Container>
        </section>
    )
}
